import React from 'react'

export default function blog() {
  return (
    <div>
        <h1>blog</h1>
      
    </div>
  )
}
